export * from './testkit';
var relativePath = '/storage';
export var createUserStorageApi = function (baseUrl, http) {
    var apiUrl = baseUrl + relativePath;
    return {
        getAll: function () {
            return http.get("".concat(apiUrl, "/keys"));
        },
        get: function (key) {
            return http.get("".concat(apiUrl, "/entry?key=").concat(key));
        },
        set: function (key, value) {
            return http.post("".concat(apiUrl, "/entry"), { key: key, value: value });
        },
        setMany: function (entries) {
            return http.post("".concat(apiUrl, "/entries"), { entries: entries });
        },
        delete: function (key) {
            return http.delete("".concat(apiUrl, "/entry?key=").concat(key));
        },
    };
};
//# sourceMappingURL=index.js.map